import { useContext } from 'react';

import { HiveRenderingMetadataContext } from '../context/hive-rendering-metadata.context.js';

export const useHiveRenderingMetadata = () =>
  useContext(HiveRenderingMetadataContext);
